<template>
  <div class="font-select">
    <label v-if="label" class="font-select__label">{{ label }}</label>
    <v-select
      :value="value"
      :items="items"
      item-text="label"
      item-value="value"
      outlined
      dense
      hide-details
      class="font-select__field"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'FontSelect',
  props: {
    label: { type: String, default: '' },
    value: { type: String, default: '' },
    /** Options: { label, value }[] */
    items: { type: Array, default: () => [] },
  },
}
</script>

<style scoped>
.font-select__label {
  display: block;
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 6px;
  cursor: default;
}

.font-select__field >>> .v-input__slot fieldset {
  border-radius: 8px;
  border-color: rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.15);
}

.font-select__field >>> .v-input__slot fieldset:hover {
  border-color: rgba(255, 255, 255, 0.14);
}
</style>
